import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { useEffect, useMemo, useState } from 'react'

type Props = {
  services: ILeadOppProduct[]
}

export function useData(props: Props) {
  const { services } = props
  const [servicesReOrderTemp, setServicesReOrderTemp] = useState<
    ILeadOppProduct[]
  >([])

  const [disableCancel, setDisableCancel] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)

  useEffect(() => {
    setServicesReOrderTemp(services)
  }, [services])

  const formDirty = useMemo(() => {
    const originalIds = services.map((x) => x.id).join(',')
    const currentIds = servicesReOrderTemp.map((x) => x.id).join(',')

    return originalIds != currentIds
  }, [servicesReOrderTemp, services])

  const disableSave = isSaving || !formDirty

  return {
    disableCancel,
    disableSave,
    formDirty,
    isSaving,
    servicesReOrderTemp,
    setDisableCancel,
    setDisableSave: setIsSaving,
    setServicesReOrderTemp,
  } as const
}
export type UseData = ReturnType<typeof useData>
